export const USER_FIELDS = {
  NAME: 'name',
  STATUS: 'status',
  EMAIL: 'email',
  ACTIONS: 'actions',
};
